"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { FC, useEffect, useLayoutEffect, useState } from "react";
import { useRef } from "react";

import BentoBlock from "@/components/BentoList/BentoBlock";
import { BentoListProps } from "@/types";

const BentoList: FC<BentoListProps> = ({ entry }) => {
  const [delta, setDelta] = useState(0);
  const targetRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  let x = useTransform(scrollYProgress, [0, 1], ["0", `${delta}px`]);

  useEffect(() => {
    if (gridRef.current && containerRef.current) {
      const d = containerRef.current.getBoundingClientRect().width - gridRef.current.getBoundingClientRect().width;
      setDelta(d);
    }
  }, [gridRef, containerRef]);

  useLayoutEffect(() => {
    const updateSize = () => {
      if (gridRef.current && containerRef.current) {
        const d = containerRef.current.getBoundingClientRect().width - gridRef.current.getBoundingClientRect().width;
        setDelta(d);
      }
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [gridRef, containerRef]);

  return (
    <>
      <div className="pt-xxl w-22\/24 md:w-20\/24 mx-auto">
        {entry.title && (
          <div className="w-full pt-xxl pb-l">
            {entry.title && (
              <h2 className="font font-primary uppercase text-l md:text-xl text-center font-normal leading-5 md:leading-10 tracking-widest">
                {entry.title}
              </h2>
            )}
          </div>
        )}

        {entry.subtitle && <p className="font-secondary text-[14px] font-secondary-light leading-5 text-center mb-[40px]">{entry.subtitle}</p>}
      </div>
      <div ref={targetRef} style={{ height: `${entry.modules.length * 100}vh` }} className={`delta-${delta} pb-xl`}>
        <div className="sticky top-3xl md:top-5xl overflow-hidden">
          <div ref={containerRef} className="relative w-22\/24 md:w-20\/24 mx-auto">
            <div className="flex">
              <motion.div ref={gridRef} style={{ x }} className="flex gap-xs">
                {entry.modules.map((block, i: number) => {
                  return <BentoBlock key={i} block={block} />;
                })}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BentoList;
